import { useQuery, useMutation } from "@apollo/client";
import { makeStyles, useTheme, Typography } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import Select from './Select';
import fp from 'lodash/fp';
import gql from "graphql-tag";
import React from 'react';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  title: {
    flex: '0 0 auto',
  },
  main: {
    flex: '1 0 auto',
    display: 'flex',
  },
  select: {
    margin: '-2px 0 0 4px',
    flex: '0 0 auto',
    minWidth: '25%',
    '& .MuiInputBase-root': {
      color: 'inherit',
      verticalAlign: 'text-top',
    },
    '& .MuiTypography-root': {
      whiteSpace: 'nowrap',
      overflowX: 'hidden',
      maxWidth: '50vw',
      fontSize: '1.25rem',
    }
  },
}));

const GET_ORGANIZATIONS = gql`
  query getOrganizations(
    $ids: [ID]
  ) {
    organizations(
      ids: $ids
    ) {
      id
      name
    }
  }
`;

const UPDATE_USER = gql`
  mutation updateUser(
    $id: ID!
    $organizationId: ID!
  ) {
    updateUser(
      id: $id
      organizationId: $organizationId
    ) {
      id
      organization {
        id
      }
    }
  }
`;


export default function AppBarTitleAdmin({ location, organizationId, userId, dispatch }) {
  const classes = useStyles();
  const theme = useTheme();
  const [updateUser] = useMutation(UPDATE_USER);
  const history = useHistory();
  const { t } = useTranslation(['translations', 'layout', 'user']);
  const { data, loading, error } = useQuery(GET_ORGANIZATIONS, {
    variables: {},
    fetchPolicy: 'cache-first',
    notifyOnNetworkStatusChange: true,
  });

  const [organizationValue, setOrganizationValue] = React.useState(null);

  if (loading || !userId) {
    return (<div>...</div>);
  } else if (error) {
    console.error(error);
    return (<div>{error}</div>);
  }

  const organizations = data?.organizations.map((o) => ({
    label: o.name,
    value: String(o.id),
  }));

  const firstPath = location.pathname.split('/').filter((s) => !!s)[0];
  const title = t(`layout:/${firstPath}`);

  const onOrganizationChange = ({ value }) => {
    updateUser({
      variables: {
        id: userId,
        organizationId: value,
      },
    }).then((res) => {
      setOrganizationValue(value);
      dispatch({
        type: 'UPDATE_ME',
        payload: res.data.updateUser,
      });
      setTimeout(function () {
        history.go(0);
      }, 100);
    }).catch((err) => {
      console.error(err);
    });
  };

  const selectStyles = {
    input: (base) => ({
      ...base,
      color: theme.palette.background.default,
    }),
  };

  return <div className={classes.main}>
    <Typography variant="h6" noWrap className={classes.title}>{title} - </Typography>
    <Select
      className={classes.select}
      placeholder={t('user:Choose an organization')}
      options={organizations}
      onChange={onOrganizationChange}
      defaultValue={fp.find({ value: organizationId }, organizations)}
      value={fp.find({ value: organizationValue }, organizations)}
      styles={selectStyles}
      TextFieldProps={{
        required: true,
        margin: 'none',
        title: t('user:Choose an organization'),
      }}
    />
  </div>
    ;

}
